<template>
  <section class="page-left-side">
    <el-menu :default-active="$route.path" router class="left-side-menu">
      <template v-for="(item, index) in menuList" :key="index">
        <el-sub-menu v-if="item?.children?.length > 0" :index="`sub-${index}`">
          <template #title>
            <el-icon><component :is="item.icon" /></el-icon>
            <span>{{ item.title }}</span>
          </template>
          <el-menu-item
            v-for="(_item, _index) in item.children"
            :key="`${index}-${_index}`"
            :index="_item.path"
            :disabled="!!_item.disabled"
          >
            {{ _item.title }}
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item v-else :index="item.path" :disabled="!!item.disabled">
          <el-icon><component :is="item.icon" /></el-icon>
          <span>{{ item.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import {
  Document,
  Notebook,
  Tickets,
  User,
  Wallet,
  DataBoard,
  Orange,
  VideoPause,
  Money,
  Shop,
} from '@element-plus/icons-vue'
import { menuList as baseMenuList } from '@/assets/menuList'

const iconMap = {
  数据看板: DataBoard,
  商品管理: Document,
  订单管理: Tickets,
  资产管理: Wallet,
  细胞学院: Orange,
  案例管理: Notebook,
  课程管理: Notebook,
  资讯管理: Tickets,
  用户管理: VideoPause,
  城市服务商: User,
  分销商: User,
  医院服务商: User,
  广告位管理: Money,
  模小圈: Shop,
  系统管理: Notebook,
}

const menuList = computed(() =>
  baseMenuList.map((item) => ({
    ...item,
    icon: iconMap[item.title] || Document,
  })),
)
</script>

<style scoped lang="less">
@import 'index.less';

.left-side-menu {
  border-right: none;
}
</style>
